import type { TFunction } from 'i18next';
import type { RowAction } from 'design-system-web';

import {
  CoverageHoursTableRow,
  isCoverageHoursRouting,
} from './coverageHoursTableRows';
import { CoverageHoursRouting } from './useCoverageHours';

// A shift row is a sub-row of its routing; the routing owns the actions, so hiding both on a
// child leaves it with no menu at all rather than a menu that does nothing.
const isShiftBlockRow = (row: CoverageHoursTableRow) =>
  !isCoverageHoursRouting(row);

export function buildCoverageHoursRowActions(
  t: TFunction,
  onDelete: (routing: CoverageHoursRouting) => void,
  isDeleteDisabled: boolean
): RowAction<CoverageHoursTableRow>[] {
  return [
    {
      label: t('web.admin.serviceRequest.settings.coverageHours.actions.edit'),
      onClick: () => undefined,
      isHidden: isShiftBlockRow,
      testId: 'coverageHoursRowActionEdit',
    },
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.actions.delete'
      ),
      onClick: row => {
        if (isCoverageHoursRouting(row)) {
          onDelete(row);
        }
      },
      isHidden: isShiftBlockRow,
      isDisabled: isDeleteDisabled,
      testId: 'coverageHoursRowActionDelete',
    },
  ];
}
